module.exports = __webpack_public_path__ + "9293fd371297da0682316004e3ae6cd2.svg";